<template>
    <section class="review-section">
        <div class="custom-container">
            <div class="row">
                <div class="review-header">
                    <h2>Testimoni</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <div class="review-slider"> -->
                        
                    <slick class="sslider top-courses-slider" :options="slickOptions">
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Football</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div>
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Badminton</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div>
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Basketball</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div>
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Football</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div>
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Badminton</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div>
                        <div class="review-widget">
                            <div class="review-user-info">
                                <div class="review-img">
                                    <img src="@/assets/img/user.png" alt="Blog" class="img-fluid" />
                                </div>
                                <div class="review-user">
                                    <h2><a href="javascript:void(0);">John Doe</a></h2>
                                    <h6>Basketball</h6>
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star"></i>
                                        <span>4.1</span>
                                    </div>
                                </div>
                            </div>
                            <div class="review-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat orci enim, mattis nibh aliquam dui, nibh faucibus aenean. Eget volutpat sed fermentum, eget tincidunt aliquet. Et, amet, scelerisque ultrices.Quam eu tellus congue ridiculus quam scelerisque sed.</p>
                            </div>
                        </div> 
                    </slick>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import topcourses from '../../../assets/json/topcourses'
const courseimages = require.context('@/assets/img/courses', false, /\.png$|\.jpg$/)
const userimages = require.context('@/assets/img', false, /\.png$|\.jpg$/)

export default {
    data() {
        return {
            topcourses: topcourses,
             slickOptions: {
                dots: false,
                autoplay:false,
                infinite: true,
                variableWidth: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        }
    },
     methods: {
	  loadImg(imgPath, type) {
          if(type === 1) {
              return courseimages('./' + imgPath)
          } else {
              return userimages('./' + imgPath)
          }
        
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/HomePage/Reviews/index.vue